import wixWindow from 'wix-window';
import { fireBIEvent } from 'public/bi-events.js';

let formFactor = wixWindow.formFactor;

let repeaterData;

$w.onReady(function () {
       $w('#box6').onClick(() => {
        const biFields = {
            ctaName: "toggle",
            targetUrl: '/'
        }
        fireBIEvent(19, 12003, biFields);
    })
    repeaterData = $w('#repeater10').data;
    sendBiEvent();
    $w("#datasetLogos").onReady(() => {
        console.log("The dataset is ready");
        if (formFactor === "Mobile") {
            $w("#datasetLogos").setPageSize(20)
                .then(() => {
                    console.log("Page size set.");
                })
                .catch((err) => {
                    let errMsg = err.message;
                    let errCode = err.code;
                });
        }
    });

});

const sendBiEvent = () => {

    $w('#box44').onClick(() => {
        const biFields = {
            ctaName: $w('#button9').label,
            pageName: 'Ideas',
            section: 'first_fold',
            targetUrl: $w('#button9').link
        }
        fireBIEvent(19, 12001, biFields);
    })
    $w('#box99').onClick(() => {
        const biFields = {
            ctaName: $w('#button25').label,
            pageName: 'Ideas',
            section: 'first_fold',
            targetUrl: $w('#button9').link
        }
        fireBIEvent(19, 12001, biFields);
    });

    $w("#repeater10").onItemReady(($item, itemData, index) => {
        const obj = {
            container: '#box94',
            ctaName: $item('#button24').label,
            pageName: 'homepage',
            section: 'fourth_fold',
            subSection: $item('#text45').text,
            targetUrl: $item('#button24').link
        }
        const {
            subSection,
            ctaName,
            pageName,
            section,
            targetUrl,
        } = obj;

        $item('#box94').onClick(() => {
            const biFields = {
                ctaName,
                pageName,
                section,
                subSection,
                targetUrl
            }
            fireBIEvent(19, 12002, biFields);
        });
    });
    $w('#repeater10').data = repeaterData;

}